import { type CSSProperties } from "react";
import { useV3Theme } from "../../hooks/use-v3-theme";
import { useWorkspaceInfo } from "../../../lib/hooks/use-kuvio";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";
import { UserMenu } from "./UserMenu";
import { MyTasksBadge } from "./MyTasksBadge";
import { CmdKHint } from "../command-palette/CmdKHint";

export function TopBar() {
  const { theme, toggle } = useV3Theme();
  // №13.4.1 (D-NAV1) — the return leg of the two-way console↔app link. "Open app"
  // shows only when the App Shell is reachable (ledger/product surface enabled),
  // mirroring the App's flag gate; single click, current workspace (session-carried).
  const wsInfo = useWorkspaceInfo();
  const appReachable = wsInfo.data?.ledger_enabled === true;

  const bar: CSSProperties = {
    height: 48,
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    borderBottom: "var(--kuvio-border-default)",
    background: "var(--color-background-primary)",
    fontFamily: "var(--font-sans)",
    gap: 8,
  };

  // Sprint 9a — top chrome is identity + utilities only. Primary navigation
  // (Agents / Tables / My tasks / Activity) moved into the left rail's
  // Workspace section; the misleading Cmd-K placeholder was removed (Sprint 3
  // brings the real command palette back when specced). MyTasksBadge stays as a
  // compact at-a-glance indicator that mirrors the rail's My tasks item.
  return (
    <header style={bar}>
      <WorkspaceSwitcher />

      <div style={{ flex: 1 }} />

      {appReachable && (
        <a
          href="/app"
          aria-label="Open the app for this workspace"
          style={{ display: "inline-flex", alignItems: "center", gap: 6, textDecoration: "none", padding: "5px 10px", borderRadius: "var(--border-radius-md)", border: "var(--kuvio-border-default)", fontSize: 13, color: "var(--color-text-primary)", background: "transparent" }}
        >
          <i className="ti ti-external-link" style={{ fontSize: 15 }} aria-hidden="true" /> Open app
        </a>
      )}

      <button
        onClick={toggle}
        aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
        style={{ border: "none", background: "transparent", padding: 6, display: "flex" }}
      >
        <i
          className={`ti ${theme === "dark" ? "ti-sun" : "ti-moon"}`}
          style={{ fontSize: 18, color: "var(--color-text-secondary)" }}
          aria-hidden="true"
        />
      </button>

      <CmdKHint />

      <MyTasksBadge />

      <UserMenu />
    </header>
  );
}
